import InputMask from "react-input-mask";
import { TextField } from "@mui/material";
import React, { useState } from "react";
export const MyIdentityNumberField = (props) => {
  const [maskChar, setMaskChar] = useState(null);
  let error = props.helperText !== "" && props.helperText !== null && props.helperText !== undefined;
  const inputMode = props.inputMode ? props.inputMode : "text";
  return (
    <InputMask
      aria-label={props.label}
      size={props.size ? props.size : "medium"}
      name={props.label}
      mask={"99999999-***9"}
      alwaysShowMask={false}
      maskChar={maskChar}
      style={{ width: "100%", margin: "1rem 0", ...props.style }}
      helperText={props.helperText}
      error={error}
      value={props.value}
      variant="outlined"
      label={props.label}
      onChange={(e) => {
        if (e.target.value == "________-____") {
          setMaskChar(null);
          props.onChange("");
        } else {
          setMaskChar("_");
          props.onChange(e.target.value);
        }
      }}
      placeholder={props.placeholder}
      type={props.type}
      onKeyPress={props.onKeyPress}
    >
      {(inputProps) => <TextField autoComplete="off" required={props.required} inputProps={{ inputMode: inputMode }} {...inputProps} type="text" />}
    </InputMask>
  );
};
